/* eslint-disable no-unused-vars */

class ValidationPipeline {
  constructor(value, target = '') {
    this.currentData = value;
    this.pass = true;
    this.error = null;
    this.target = target;
  }

  dryCondition(condition, error) {
    if ((this.currentData || this.currentData === '') && this.pass) {
      if (condition) {
        this.pass = true;
      } else {
        this.pass = false;
        this.error = !this.error && error.replace(/&#39;/g, "'").replace(/&amp;/g, '&');
      }
    }
  }

  format(callback) {
    this.currentData = callback(this.currentData);

    return this;
  }

  max(maxChars, errMsg) {
    this.dryCondition(this.currentData.length < maxChars, errMsg);

    return this;
  }

  min(minChars, errMsg) {
    this.dryCondition(this.currentData.length >= minChars, errMsg);

    return this;
  }

  nand(selectors, errMsg) {
    this.dryCondition(!selectors.every(Boolean), errMsg);

    return this;
  }

  required(errMsg) {
    this.dryCondition(this.target.checked, errMsg);

    return this;
  }

  notEmpty(errMsg) {
    this.dryCondition(this.currentData !== '', errMsg);

    return this;
  }

  pattern(pattern, errMsg, inverse) {
    const invertedTest = inverse
      ? !pattern.test(this.currentData)
      : pattern.test(this.currentData);

    this.dryCondition(invertedTest, errMsg);

    return this;
  }

  string(errMsg) {
    this.dryCondition(typeof this.currentData === 'string', errMsg);

    return this;
  }

  trim() {
    if (this.pass && typeof this.currentData === 'string') this.currentData = this.currentData.trim();

    return this;
  }

  validate() {
    return {
      pass: this.pass,
      error: this.error,
    };
  }
}
